import Cookies from 'universal-cookie';
import { DataManager } from './DataManager';
var decode = require('decode-html');

//var beautify = require('xml-beautifier');

//export const Evalute = (script: string, data: any) => {
//    let funDatabound = eval("(t) => t." + script);
//    let result = funDatabound(data);
//    return result;
//}

export const EvaluteExpression = (expression: string, dataItem: any, dataIndex: number, appState:any,dataState:any) => {
    if (dataItem) {
        const cookies = new Cookies();
        let dataManager = new DataManager(appState);
        var funExpression = eval("($$t,$$index,appState,cookies,dataManager,dataState) => " + decode(expression.trim()));
        //return funExpression(dataItem, dataIndex, appState, beautify);
        return funExpression(dataItem, dataIndex, appState, cookies, dataManager, dataState);
    }
    else if (dataItem === null) {
        //return false;
        return "null";
    }
    else if (dataItem === undefined) {
        //return false;
        return "undefined";
    }
    else {
        return "";
    }
};


//export const Eval = (script: string) => {    
//    let result = eval(script)
//    return result;
//}